import {CityImprovementTypes, MechanicCityImprovementsPlayerState} from '@colonist/game-states'
import styles from './UIGameCityImprovementTracker.module.scss'
import clsx from 'clsx'
import {UIGameCityImprovementTrackerColumn} from './UIGameCityImprovementTrackerColumn/UIGameCityImprovementTrackerColumn'
import React from 'react'

export interface UIGameCityImprovementTrackerProps {
    cityImprovementState: MechanicCityImprovementsPlayerState
    className?: string
}

export function UIGameCityImprovementTracker({
    cityImprovementState,
    className,
}: UIGameCityImprovementTrackerProps) {
    const columns: React.ReactNode[] = []

    const cityImprovementTypes = [CityImprovementTypes.Science, CityImprovementTypes.Trade, CityImprovementTypes.Politics]
    for(const type of cityImprovementTypes) {
        columns.push(<UIGameCityImprovementTrackerColumn
            className={styles.column}
            cityImprovementType={type}
            hasMetropolis={cityImprovementState[type]?.hasMetropolis ?? false}
            key={type}
            level={cityImprovementState[type]?.level ?? 0}
        />)
    }

    return (
        <div className={clsx(styles.container, className)}>
            {columns}
        </div>
    )
}
